<h2>Productie klaar</h2>

<div class="upper-space">
  <div class="d-flex label-with-number">
    <label>Huidig aantal in productie</label>
    <input type="number" [ngModel]="currentProductionStock" disabled />
  </div>

  <div class="d-flex label-with-number">
    <label>Aantal naar dak</label>
    <input type="number" [(ngModel)]="amountRoof" />
  </div>

  <div class="d-flex label-with-number">
    <label>Aantal naar rek</label>
    <input type="number" [(ngModel)]="amountShelf" />
  </div>

  <button
    *ngIf="!saving"
    type="button"
    mat-button
    class="button"
    [disabled]="amountRoof + amountShelf !== currentProductionStock"
    (click)="save()"
  >
    Bewaar
  </button>
  <mat-spinner *ngIf="saving" color="primary" diameter="24"></mat-spinner>
</div>
